var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



/*****************
 ** WEBPACK FOOTER
 ** ./~/enquire.js/src/index.js
 ** module id = 731
 ** module chunks = 0
 **/